export default __webpack_public_path__ + "static/media/go-to-computer.4bfaf69e.png";